import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  quote: 'Organicé todo el año en una tarde',
  name: 'Camila G.',
  location: 'Buenos Aires | secundaria'
}, {
  initials: 'MG',
  quote: 'Mis clases de Química por fin enganchan',
  name: 'Martín G.',
  location: 'GBA | secundaria'
}, {
  initials: 'LG',
  quote: 'Nunca más improvisé una evaluación',
  name: 'Laura G.',
  location: 'Córdoba | secundaria'
}];
export function ShortTestimonials() {
  return <section className="py-16 px-4 bg-brand-gray" data-id="element-292">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-293">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center text-center" data-id="element-294">
            <div className="w-16 h-16 bg-brand-blue text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-295">
              {t.initials}
            </div>
            <div className="flex text-yellow-400 mb-4" data-id="element-296">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-297" />)}
            </div>
            <p className="text-lg font-bold text-gray-800 mb-4 italic" data-id="element-298">
              "{t.quote}"
            </p>
            <p className="text-sm text-gray-500 font-medium" data-id="element-299">
              — {t.name}, {t.location}
            </p>
          </div>)}
      </div>
    </section>;
}